"use client"

import Box from "@mui/material/Box"
import Skeleton from "@mui/material/Skeleton"
import Stack from "@mui/material/Stack"

/** Mirrors the shared ProductCard layout while catalog data loads. */
export const ProductCardSkeleton = () => (
  <Box
    width="100%"
    aria-hidden="true"
    sx={{
      boxSizing: "border-box",
      bgcolor: "#FFFFFF",
      border: "1px solid #ECE9E9",
      boxShadow: "0 8px 22px rgba(26, 20, 20, .08)",
      borderRadius: "20px",
      p: { xs: "8px", md: "14px" },
      position: "relative",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      "& .MuiSkeleton-root": { transform: "none" },
      "@media (prefers-reduced-motion: reduce)": {
        "& .MuiSkeleton-root, & .MuiSkeleton-root::after": { animation: "none" }
      }
    }}
  >
    <Box
      sx={{
        position: "relative",
        width: "100%",
        aspectRatio: "1 / 1",
        minHeight: { xs: 0, md: "200px" },
        borderRadius: "14px",
        overflow: "hidden",
        bgcolor: "#F0EFF2"
      }}
    >
      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", bgcolor: "#F0EFF2" }}
      />
      <Skeleton
        variant="circular"
        animation="wave"
        sx={{
          position: "absolute",
          top: 8,
          right: 8,
          width: { xs: 36, md: 42 },
          height: { xs: 36, md: 42 },
          bgcolor: "rgba(255,255,255,.85)"
        }}
      />
    </Box>

    <Stack mt={{ xs: 1, md: 2 }} direction="column" spacing={{ xs: 0.75, md: 1.5 }} sx={{ flex: 1, px: 0.25 }}>
      <Stack direction="column" justifyContent="center" gap="7px" sx={{ height: "37.8px" }}>
        <Skeleton animation="wave" variant="rounded" width="94%" height={12} sx={{ borderRadius: "3px", bgcolor: "#E5E2DF" }} />
        <Skeleton animation="wave" variant="rounded" width="72%" height={12} sx={{ borderRadius: "3px", bgcolor: "#E5E2DF" }} />
      </Stack>

      <Box sx={{ height: 24, display: "flex", alignItems: "center" }}>
        <Skeleton animation="wave" variant="rounded" width="42%" height={16} sx={{ borderRadius: "4px", bgcolor: "#D6D2CE" }} />
      </Box>

      <Stack direction="row" gap={1} sx={{ py: 0.5 }}>
        {[0, 1, 2].map(index => (
          <Skeleton key={index} animation="wave" variant="circular" sx={{ flexShrink: 0, width: { xs: 30, md: 32 }, height: { xs: 30, md: 32 }, bgcolor: "#EFEBE7", border: "1px solid #ECECEC" }} />
        ))}
      </Stack>

      <Stack direction="row" spacing={1} sx={{ mt: "auto !important", pt: 1 }}>
        <Skeleton animation="wave" variant="rounded" sx={{ flex: 1, height: { xs: 32, md: 44 }, borderRadius: "999px", bgcolor: "#D1CECB" }} />
        <Skeleton animation="wave" variant="circular" sx={{ display: { xs: "none", md: "block" }, flexShrink: 0, width: { xs: 32, md: 44 }, height: { xs: 32, md: 44 }, bgcolor: "#F8F6F3", border: "1px solid #E5E0DC" }} />
      </Stack>
    </Stack>
  </Box>
)
